import { render } from "./FilterPrice.vue?vue&type=template&id=42771572&ts=true"
import script from "./FilterPrice.vue?vue&type=script&lang=ts"
export * from "./FilterPrice.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__